module.exports = __webpack_public_path__ + "static/img/1.30cab3bc.png";